// import React from "react";
// import "./StrategyMission.css";
// import picture from "../../../images/missbg.jpg";

// function StrategyMission() {
//   return (
//     <div className="container-fluid Smission">
//       <div className="container my-5 ">
//         <div className="d-flex flex-column justify-content-center align-items-center h-100  py-3 stra-mission">
//           <div className="arrow ps-2 "></div>
//           <div>
//             <div className="fs-1 fw-bold head-text heaing hero-text-clr d-flex align-items-center ">
//               Our Mission
//             </div>
//             <p className="mt-1 fs-5 paras">
//               Our mission is very simple. We want to professionally and
//               financially develop people who are founders and leaders of our
//               portfolio companies as well as customers of our portfolio
//               companies.
//             </p>
//           </div>
//           <div className="arrow arrow2 ps-2"></div>
//           <div className="  mt-2">
//             <div className="fs-1 fw-bold head-text heaing  hero-text-clr d-flex align-items-center">
//               Our Strategy
//             </div>
//             <p className="mt-1 fs-5 paras ">
//               We invest in leaders and founders wo have deep domain expertise in
//               workforce development and talent transformation.
//             </p>
//           </div>
//         </div>
       
//       </div>
//     </div>
//   );
// }

// export default StrategyMission;
import React from "react";
import "./StrategyMission.css";
import strategyHero from "../../../images/Strategy.png";

const StrategyMission = () => {
  return (
    <section
      className="strategy-mission"
      style={{
        backgroundImage: `linear-gradient(
          to right,
          rgba(247, 224, 204, 0.92),
          rgba(247, 224, 204, 0.82),
          rgba(247, 224, 204, 0.45),
          rgba(247, 224, 204, 0.12)
        ), url(${strategyHero})`,
      }}
    >
      <div className="container">
        <div className="strategy-mission-content">
          <h1 className="strategy-main-title">
            <span className="darkO-txt">We Don't Just Fund EdTech.</span>{" "}
            We Build Skills-Based Infrastructure With You.
          </h1>

          <div className="strategy-block">
            <h2 className="hero-title">Mission</h2>
            <p className="hero-para">
              Our mission is to professionally and financially develop the
              founders of our portfolio companies — and in turn, transform how
              the world measures skills, hires talent, and builds careers.
            </p>
          </div>

          <div className="strategy-block">
            <h2 className="hero-title">
              Who <span className="darkO-txt">We Back</span>
            </h2>
            <p className="hero-para">
              We invest in founders with deep domain expertise in workforce
              development, talent intelligence, skills-based hiring,
              performance assessment, and industry-specific training.
            </p>
            <p className="hero-para">
              If you've lived the problem, we'll help you build the
              infrastructure that solves it.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StrategyMission;